import React from 'react';

import { Button, ContainerBanner } from '~components';
import { faInfoCircle } from '~components/icon';
import Modal from '~components/Modal';

import { Supplement, isSupplementRateStale } from '~lookups/models';

import { useGetLookupSupplementsQuery } from '~lookups/actions/supplements';

import BudgetSupplements from './BudgetSupplements';

interface ComponentProps {
  isOpen?: boolean;
  setIsOpen: (toggle: boolean) => void;
  value: { supplements: Supplement[]; package_fixed_id?: number };
  onChange?: (name: string, value: any) => void;
}

const BudgetSupplementsModal: React.FC<ComponentProps> = ({ value, onChange, isOpen, setIsOpen }) => {
  const { data: activeSupplementRates = [], isFetching: isLoadingRates } = useGetLookupSupplementsQuery();

  const supplements = value.supplements ?? [];
  const isStale = supplements.some((sup) => isSupplementRateStale(sup.supplement));

  const handleUpdateRates = () => {
    const updated = supplements.map((sup) => {
      if (!isSupplementRateStale(sup.supplement)) return sup;

      const activeRate = activeSupplementRates.find(
        (rate) => rate.label === sup.supplement?.label && rate.type === sup.supplement?.type,
      );
      if (!activeRate) return sup;

      return {
        ...sup,
        supplement_id: activeRate.id,
        supplement: activeRate,
        amount: 0,
      };
    });

    onChange?.('supplements', updated);
  };

  const footer = isStale ? (
    <>
      <Button
        id="update-supplement-rates-button"
        color="warning"
        onClick={handleUpdateRates}
        loading={isLoadingRates}
        aria-label="Update rates"
      >
        Update rates
      </Button>
      <Button color="info" className="ms-2" onClick={() => setIsOpen(false)}>
        Close
      </Button>
    </>
  ) : undefined;

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      header="Edit Budget Supplements"
      headerClassName="header"
      size="lg"
      footer={footer}
    >
      {isStale && (
        <ContainerBanner
          className="mb-3"
          color="info"
          icon={faInfoCircle}
          messages={[
            'Supplement & Case management rates have been updated since they were last added. Please update to rates',
          ]}
        />
      )}
      <BudgetSupplements
        type="custom"
        id="supplements"
        name="supplements"
        value={value}
        onChange={onChange}
        layout="stack"
      />
    </Modal>
  );
};

export default BudgetSupplementsModal;
